export const paymentPlanSizes = {
  maxWidth: '288px',
  height: '176px',
  mobileHeight: '118px',
};

export const expandedBottomHeight = '72px';

export const mobilePa = '72px';
